import { Navigate } from "react-router-dom";

import { useAuth } from "../hooks/useAuth";
import { useCurrentUserRole } from "../hooks/useCurrentUserRole";
import { canAccessPlatformAdmin, isPlatformSupportRole } from "../lib/platformAccess";

/**
 * Canonical post-auth landing: super_admin (`public.users`) → platform admin home;
 * platform_support → de supportwerkplek (de rest van de app is voor die rol leeg);
 * otherwise → main app home (explorer). Waits for auth and role to avoid wrong flashes/loops.
 */
export function AppHomeRedirect() {
  const { session, user, loading: authLoading } = useAuth();
  const actorId = session?.user?.id ?? user?.id;
  const { role, isLoading: roleLoading, isError } = useCurrentUserRole(actorId);

  if (authLoading || roleLoading) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center text-sm text-muted-foreground">Laden…</div>
    );
  }

  if (!session?.user?.id) {
    return <Navigate to="/login" replace />;
  }

  if (isError) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center px-4 text-center text-sm text-red-600">
        Kon gebruikersrol niet laden. Controleer of dit account een rij in public.users heeft.
      </div>
    );
  }

  const destination = canAccessPlatformAdmin(role)
    ? "/app/internal/platform"
    : isPlatformSupportRole(role)
      ? "/app/support"
      : "/app/explorer";
  return <Navigate to={destination} replace />;
}
